import React, { Component } from 'react';
import '../../../../../styles/components/money-flow-dashbaord/donut.scss';
import { OMR } from '../../../../common/icons';
import { fmt } from '../../../../../utils/common';

class Donut extends Component {
  render() {
    const { segments } = this.props;
    const size = 150,
      sw = 24,
      r = (size - sw) / 2,
      circ = 2 * Math.PI * r;
    const total = segments.reduce((s, d) => s + d.value, 0);
    if (total === 0) return null;
    let offset = 0;
    const segs = segments.map((d) => {
      const dash = (d.value / total) * circ * 0.94;
      const seg = { ...d, dash, offset };
      offset += (d.value / total) * circ;
      return seg;
    });
    return (
      <div className="donut">
        <div className="donut__chart" style={{ width: size, height: size }}>
          <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
            {segs.map((s, i) => (
              <circle
                key={i}
                cx={size / 2}
                cy={size / 2}
                r={r}
                fill="none"
                stroke={s.color}
                strokeWidth={sw}
                strokeDasharray={`${s.dash} ${circ - s.dash}`}
                strokeDashoffset={-s.offset}
                strokeLinecap="butt"
              />
            ))}
          </svg>
          <div className="donut__center">
            <div className="donut__total">{fmt(total)}</div>
            <OMR size={9} style={{ opacity: 0.5, marginTop: 2 }} />
          </div>
        </div>
        <div className="donut__legend">
          {segs.map((s, i) => (
            <div key={i} className="donut__legend-item">
              <div className="donut__dot" style={{ background: s.color }} />
              <span className="donut__label">{s.label}</span>
              <span className="donut__pct">{Math.round((s.value / total) * 100)}%</span>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default Donut;
